import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { reExportedColors } from '../index'

export default function ModalBase ({ children, open, setOpen, className, sx }) {
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        className={className}
        sx={[
          (theme) => ({
            backgroundColor: reExportedColors.WHITE,
            borderRadius: '4px',
            boxShadow: theme.shadows[5],
            left: '50%',
            maxHeight: '90vh',
            minWidth: '600px',
            outline: 'none',
            overflowY: 'auto',
            position: 'absolute',
            top: '50%',
            transform: 'translate(-50%, -50%)'
          }),
          ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])
        ]}
      >
        {children}
      </Box>
    </Modal>
  )
}
